var map = {
	"./1-trend-01-topright.svg": "./src/deicons/svg/1-trend-01-topright.svg",
	"./1-trend-02-bottomright.svg": "./src/deicons/svg/1-trend-02-bottomright.svg",
	"./1-trend-03-topleft.svg": "./src/deicons/svg/1-trend-03-topleft.svg",
	"./1-trend-04-bottomleft.svg": "./src/deicons/svg/1-trend-04-bottomleft.svg",
	"./1-trend-05-top.svg": "./src/deicons/svg/1-trend-05-top.svg",
	"./1-trend-06-right.svg": "./src/deicons/svg/1-trend-06-right.svg",
	"./1-trend-07-left.svg": "./src/deicons/svg/1-trend-07-left.svg",
	"./1-trend-08-bottom.svg": "./src/deicons/svg/1-trend-08-bottom.svg",
	"./1-trend-09-top1.svg": "./src/deicons/svg/1-trend-09-top1.svg",
	"./1-trend-10-bottom1.svg": "./src/deicons/svg/1-trend-10-bottom1.svg",
	"./1-trend-11-left1.svg": "./src/deicons/svg/1-trend-11-left1.svg",
	"./1-trend-12-right1.svg": "./src/deicons/svg/1-trend-12-right1.svg",
	"./2-state-01-diamond.svg": "./src/deicons/svg/2-state-01-diamond.svg",
	"./2-state-02-triangle.svg": "./src/deicons/svg/2-state-02-triangle.svg",
	"./2-state-03-circle.svg": "./src/deicons/svg/2-state-03-circle.svg",
	"./2-state-04-pentagon.svg": "./src/deicons/svg/2-state-04-pentagon.svg",
	"./2-state-05-square.svg": "./src/deicons/svg/2-state-05-square.svg",
	"./2-state-06-flag.svg": "./src/deicons/svg/2-state-06-flag.svg",
	"./2-state-07-error.svg": "./src/deicons/svg/2-state-07-error.svg",
	"./2-state-08-warn.svg": "./src/deicons/svg/2-state-08-warn.svg",
	"./2-state-09-question.svg": "./src/deicons/svg/2-state-09-question.svg",
	"./2-state-10-ok.svg": "./src/deicons/svg/2-state-10-ok.svg",
	"./3-rank-01-half.svg": "./src/deicons/svg/3-rank-01-half.svg",
	"./3-rank-02-full.svg": "./src/deicons/svg/3-rank-02-full.svg",
	"./3-rank-03-nice.svg": "./src/deicons/svg/3-rank-03-nice.svg",
	"./3-rank-04-commonly.svg": "./src/deicons/svg/3-rank-04-commonly.svg",
	"./3-rank-05-bad.svg": "./src/deicons/svg/3-rank-05-bad.svg",
	"./3-rank-06-goodevaluate.svg": "./src/deicons/svg/3-rank-06-goodevaluate.svg",
	"./3-rank-07-badevaluate.svg": "./src/deicons/svg/3-rank-07-badevaluate.svg",
	"./3-rank-08-badevaluatecircle.svg": "./src/deicons/svg/3-rank-08-badevaluatecircle.svg",
	"./3-rank-08-goodevaluatecircle.svg": "./src/deicons/svg/3-rank-08-goodevaluatecircle.svg",
	"./4-location-01-mark.svg": "./src/deicons/svg/4-location-01-mark.svg",
	"./4-location-02-mark1.svg": "./src/deicons/svg/4-location-02-mark1.svg",
	"./4-location-03-mark2.svg": "./src/deicons/svg/4-location-03-mark2.svg",
	"./4-location-04-location.svg": "./src/deicons/svg/4-location-04-location.svg",
	"./4-location-05-location1.svg": "./src/deicons/svg/4-location-05-location1.svg",
	"./4-location-06-location2.svg": "./src/deicons/svg/4-location-06-location2.svg",
	"./4-location-07-map.svg": "./src/deicons/svg/4-location-07-map.svg",
	"./4-location-08-map1.svg": "./src/deicons/svg/4-location-08-map1.svg",
	"./5-weather-01-bigsnow.svg": "./src/deicons/svg/5-weather-01-bigsnow.svg",
	"./5-weather-02-littlesnow.svg": "./src/deicons/svg/5-weather-02-littlesnow.svg",
	"./5-weather-03-bigrain.svg": "./src/deicons/svg/5-weather-03-bigrain.svg",
	"./5-weather-04-littlerain.svg": "./src/deicons/svg/5-weather-04-littlerain.svg",
	"./5-weather-05-icerain.svg": "./src/deicons/svg/5-weather-05-icerain.svg",
	"./5-weather-06-snowrain.svg": "./src/deicons/svg/5-weather-06-snowrain.svg",
	"./5-weather-07-sunny.svg": "./src/deicons/svg/5-weather-07-sunny.svg",
	"./5-weather-08-cloudy.svg": "./src/deicons/svg/5-weather-08-cloudy.svg",
	"./5-weather-09-smog.svg": "./src/deicons/svg/5-weather-09-smog.svg",
	"./5-weather-10-typhoon.svg": "./src/deicons/svg/5-weather-10-typhoon.svg",
	"./5-weather-11-wind.svg": "./src/deicons/svg/5-weather-11-wind.svg",
	"./5-weather-12-thunder.svg": "./src/deicons/svg/5-weather-12-thunder.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/deicons/svg sync recursive ^\\.\\/.*\\.svg$";